
import PAT from '@assets/Patente.png'

type Props = {
  driverLicense?: boolean
}
const ExplainationComponent: React.FC<{
	imgSource: string
	description: string
	title: string
}> = ({ imgSource, description, title }) => (
	<div className={'flex flex-col md:flex-row items-start gap-3 md:gap-6 mb-6'}>
		<img src={`${imgSource}`} className='object-cover w-[140px] md:w-[253px] shrink-0' />
		<div className='flex flex-col gap-1.5'>
			<p className={'font-bold text-[16px] md:text-[18px] text-(--primary-blue)'}>{title}</p>
			<p className={' text-[13px] md:text-[16px] text-(--primary-text)'}>{description}</p>
		</div>
	</div>
)

const IDLicense : React.FC<Props> = ({ driverLicense }) => (
	<div >
		
		<div className={'p-2.5'}>
			
			<ExplainationComponent
					imgSource={PAT}
					description={
						'Il numero identificativo della Patente di guida si trova al punto 5, accanto alla foto. Il numero è composto da 10 caratteri alfanumerici.'
					}
					title={'Patente di guida'}
				/>
		</div>
	</div>
)

export default IDLicense


